import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { IQuestionnaireListProps, IQuestionnaireListItem } from './types';

export const QuestionnaireList: React.FC<IQuestionnaireListProps> = ({
  questionnaires,
}) => {
  const renderListItem = (questionnaire: IQuestionnaireListItem) => (
    <tr key={questionnaire.id}>
      <td>
        <Link to={`/admin/questionnaires/${questionnaire.id}`}>
          {questionnaire.name}
        </Link>
      </td>
      <td>{questionnaire.sections}</td>
      <td>{questionnaire.questions}</td>
    </tr>
  );

  return (
    <Table hover>
      <thead>
        <tr>
          <th>Name</th>
          <th>Sections</th>
          <th>Questions</th>
        </tr>
      </thead>
      <tbody>{questionnaires.map(renderListItem)}</tbody>
    </Table>
  );
};
